export default "__VITE_ASSET__b8330bf6__"